import React from 'react';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import _ from 'lodash';
import { cx, css } from 'emotion';

import ProcessField from 'components/core/fields/ProcessField';
import Constants from 'utils/Constants';
import InfoMessages from 'components/core/help/InfoMessages';
import ProcessUtils from 'utils/ProcessUtils';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIERadioGroup from 'components/core/editable/RIERadioGroup';
import ProcessService from 'services/ProcessService';
import { colorTextBlack } from 'styles/base';


const wrapperStyle = css`
    min-width: 650px;
    .editable-container {
        min-width: 650px;
    }
`;

const labelContainerStyle = css`
    display:inline-block;
`;

const labelKeyStyle = css`
    color: ${colorTextBlack} !important;
    margin-right: 8px;
    display: inline-block;
    min-width: 115px;
`;

export default class ProcessDataLocationsField extends ProcessField {

    static propTypes = Object.assign({
        runParameters: PropTypes.object,      // pass if running in runParameters mode
        runParameterErrors: PropTypes.object,  // pass if running in runParameters mode
        labelWidth: PropTypes.string
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    constructor(props) {
        super(props);
        this._initializePropDependentVariables(props);
    }
    
    componentWillReceiveProps = (nextProps) => {
        this._initializePropDependentVariables(nextProps);
    };

    _initializePropDependentVariables(props) {
        const dl = this.getDataLocations(props);
        // TODO: Should we default to the process.data_location user folder if run parameters user folder is null?
        this.userFolderPath = dl && dl.user_folder ? dl.user_folder : ProcessUtils.getProcessDefaultUserFolder();
    }

    userDataFolderChanged = (event) => {
        this.userFolderPath = event.target.value.trim();
    };

    getDataLocations(props) {
        let dl = null;
        if (props.runParameters) {
            dl = props.runParameters.data_locations;
        } else {
            dl = ProcessUtils.getDataLocations(props.process);
        } 
        return dl;
    }

    getDataLocationValue = () => {
        const dl = this.getDataLocations(this.props);
        let value = null;
        Object.keys(dl).forEach(option => {
            if (option.indexOf('use_') > -1 && dl[option]) {
                value = option;
            }
        });
        return value;
    };
    
    getDataLocationOptions() {
        const testFolderPath = ProcessUtils.getProcessTestFolder(this.props.process);

        const userFolderLabel = (
            <div className={labelContainerStyle}>
                <span className={labelKeyStyle}>User folder: </span>
                {/* TODO: need to handle errors and disabled status for the input box */}
                <input
                    className={css`margin-left: 0 !important;`}
                    defaultValue={this.userFolderPath}
                    onChange={this.userDataFolderChanged}
                    size={55}
                />
            </div>
        );

        const dmfFolderLabel = this.getDataFolderLabelComponent('DMF archive:', '/data/archive');
        const testFolderLabel = this.getDataFolderLabelComponent('Process test folder:', testFolderPath);

        const userItem = { use_user: userFolderLabel/*, checked: !!(dl && dl.use_user) */};
        const archiveItem = { use_archive: dmfFolderLabel/*, checked: !!(dl && dl.use_archive)*/ };
        const testItem = { use_test: testFolderLabel, /*checked: !!(dl && dl.use_test)*/ };

        let selections = null;
        // they have a different order depending upon what the form is used for
        if (this.props.runParameters) {
            selections = Object.assign({}, testItem, userItem, archiveItem);
        } else {
            selections = Object.assign({}, userItem, archiveItem, testItem);
        }
        return selections;
    }

    getDataFolderLabelComponent(labelKey, labelValue) {
        return (
            <div className={labelContainerStyle}>
                <span className={labelKeyStyle}>{labelKey}</span>
                <span>{labelValue}</span>
            </div>
        );
    }

    onDataLocationsUpdated = (fieldPath, value) => {
        // We also need to update our user home folder
        if (this.props.runParameters) {
            const parameters = _.cloneDeep(this.props.runParameters);
            parameters.data_locations = this.updateDataLocationsValues(parameters.data_locations, value);
            ProcessService.updateRunParameters(this.props.process.name, parameters);
        
        } else {
            //TODO: move this to process editor??
            const processCopy = _.cloneDeep(this.props.process);
            if (!processCopy.ui_state) {
                processCopy.ui_state = {};
            }
            if (!processCopy.ui_state.data_locations) {
                processCopy.ui_state.data_locations = _.cloneDeep(Constants.DATA_LOCATIONS_NEW);
            }
            this.updateDataLocationsValues(processCopy.ui_state.data_locations, value);
            ProcessService.updateProcess(this.props.process.name, processCopy);
        }
    };

    updateDataLocationsValues(dataLocations, value) {
        const userFolderPath = this.userFolderPath ? this.userFolderPath : ProcessUtils.getProcessDefaultUserFolder();
        dataLocations.user_folder = userFolderPath;

        Object.keys(dataLocations).forEach(key => {
            if (key.indexOf('use_') > -1) {
                dataLocations[key] = false;
            }
        });

        dataLocations[value] = true;
        return dataLocations;
    }

    render() {
        const labelWidth = this.props.labelWidth ? this.props.labelWidth : null;
        const errors = this.props.runParameters ? this.props.runParameterErrors : this.props.processErrors;
        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={cx(wrapperStyle, this.props.className)}>
                <InfoBoxLabel
                    label="Input File Locations"
                    message={InfoMessages.dataLocations}
                    width={labelWidth}
                    alignTop
                />
                <Flexbox flexDirection="column">
                    <RIERadioGroup
                        value={this.getDataLocationValue()}
                        options={this.getDataLocationOptions()}
                        change={this.onDataLocationsUpdated}
                        fieldPath={['ui_state', 'data_locations']}
                        isDisabled={!this.props.hasWritePermissions}
                        processId={this.props.process.name}
                        processErrors={errors}
                        vertical
                        radioGroupName="data_locations"
                        className={css`label { margin-bottom:10px; }`}
                        forceChange
                    />
                </Flexbox>   
            </Flexbox>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessDataLocationsField.js